import React, { Component } from "react";
import InputForm from "./InputForm";
import axios from "axios";


class ProdutoFrame extends Component {
    state = {
        lista: [],
        codigo: {
            key: '0',
            label: '',
        },
        buscando: false,
    }

    componentDidUpdate(propsAnterior, stateAnterior) {
        if (this.state.codigo.key !== this.props.value.key) {
            this.setState({
                codigo: {
                    key: this.props.value.key,
                    label: this.props.value.label,
                },

                lista: [{
                    key: '0',
                    label: 'Todos os Produtos',
                },
                {
                    key: this.props.value.key,
                    label: this.props.value.label,
                }]

            })
        }
    }

    componentDidMount() {
        // this.getListaRegistros();
    }

    getListaRegistros = (value) => {
        this.setState({ lista: [] })

        clearTimeout(this.buscaRegistrosId);
        this.buscaRegistrosId = setTimeout(() => {
            if (value.length >= 2) {
                this.setState({ buscando: true });

                axios.get('/produtos/listaBusca', {
                    params: {
                        nome: value,
                        verifica_prod_vend: this.props.verifica_prod_vend ? 1 : 0
                    }
                }).then(response => {
                    const { data } = response;
                    const lista = data.map(regList => {
                        return {
                            key: String(regList.prod_idf),
                            label: '[' + regList.prod_codigo + '] ' + regList.prod_descricao,
                            prod_codigo: regList.prod_codigo,
                            prod_descricao: regList.prod_descricao,
                            prod_preco_tab1: regList.prod_preco_tab1,
                            prod_preco_tab2: regList.prod_preco_tab2,
                            prod_qtde_atual: regList.prod_qtde_atual,
                            prod_peso: regList.prod_peso,
                            prod_medida2_conversao: regList.prod_medida2_conversao,
                            med_descricao: regList.med_descricao,
                        }
                    });
                    this.setState({
                        lista,
                        buscando: false,
                    })
                }).catch(error => {
                    console.error(error.response);
                    this.setState({
                        lista: [],
                        buscando: false,
                    })
                })
            }
        }, 1000);
    };

    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        const state = {};
        const iInd = this.state.lista.findIndex(registro => String(registro.key) === String(value.key));
        state[id] = {
            key: value.key,
            label: value.label,
            prod_codigo: this.state.lista[iInd].prod_codigo,
            prod_descricao: this.state.lista[iInd].prod_descricao,
            prod_preco_tab1: this.state.lista[iInd].prod_preco_tab1,
            prod_preco_tab2: this.state.lista[iInd].prod_preco_tab2,
            prod_qtde_atual: this.state.lista[iInd].prod_qtde_atual,
            prod_peso: this.state.lista[iInd].prod_peso,
            prod_medida2_conversao: this.state.lista[iInd].prod_medida2_conversao,
            med_descricao: this.state.lista[iInd].med_descricao,
        };
        this.props.onChange(state);
    };



    render() {
        const { label, id, width, disabled } = this.props;
        const { lista, codigo, buscando } = this.state;

        // console.log('ProdutoFrame: ', this.state);

        return (
            <span style={{}}>
                <span>{label}</span>
                <InputForm
                    type="select"
                    id={id}
                    ref={id}
                    value={codigo}
                    onChange={this.onChange}
                    data={lista}
                    validator={value => Boolean(value)}
                    onSearch={this.getListaRegistros}
                    fetching={buscando}
                    showArrow={false}
                    filterOption={false}
                    notFoundContent={null}
                    defaultActiveFirstOption={false}
                    showSearch
                    style={{ width: width }}
                    disabled={disabled ? true : false}
                />
            </span>
        );
    }
}

export default ProdutoFrame;



// WEBPACK FOOTER //
// ./src/components/ProdutoFrame.js